import { render, staticRenderFns } from "./GlobalConfiguration.vue?vue&type=template&id=9711dd12"
import script from "./GlobalConfiguration.vue?vue&type=script&lang=js"
export * from "./GlobalConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports